import React from "react";

const Micromobility = () => (
  <svg
    version="1.1"
    id="wes"
    x="0px"
    y="0px"
    viewBox="0 0 390 390"
    xmlSpace="preserve"
  >
    <g>
      <path
        className="st0"
        d="M334.7,277.7c-24.9,0-46,16.5-52.9,39.2H133.7l-57-115.2l36-178.8H72.4c-5,0-9.1,4.1-9.1,9.1s4.1,9.1,9.1,9.1
		h18.1L40,292c-22.1,0.5-40,18.7-40,41c0,22.6,18.4,41,41,41s41-18.4,41-41c0-16.6-10-31-24.2-37.4l10.8-53.6l37.2,75.2
		c-7.5,1.3-13.3,7.9-13.3,15.8c0,8.9,7.2,16,16,16H297c6.3,14.7,20.8,24.9,37.7,24.9c22.6,0,41-18.4,41-41c0-22.6-18.4-41-41-41
		c-16.9,0-31.5,10.3-37.7,24.9h-5.6c6.5-17.6,23.5-30.1,43.3-30.1c25.5,0,46.2,20.7,46.2,46.2c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5
		C390,302.5,365.2,277.7,334.7,277.7z M63.8,332.9c0,12.6-10.3,22.9-22.9,22.9s-22.9-10.3-22.9-22.9c0-11,7.8-20.2,18.1-22.4
		l-4.1,20.6c-1,4.9,2.2,9.7,7.1,10.7c0.6,0.1,1.2,0.2,1.8,0.2c4.2,0,8-3,8.9-7.3l4.1-20.6C59.9,318.3,63.8,325.2,63.8,332.9z
		 M334.7,310.1c12.6,0,22.9,10.3,22.9,22.9c0,12.6-10.3,22.9-22.9,22.9c-6.4,0-12.1-2.6-16.3-6.8h16.3c8.9,0,16-7.2,16-16
		s-7.2-16-16-16h-16.3C322.6,312.7,328.4,310.1,334.7,310.1z"
      />
      <polygon
        className="st0"
        points="280.5,194.3 247.1,194.3 280.8,146.6 233.3,146.6 194.8,223.6 223.3,223.6 190.7,301 	"
      />
    </g>
  </svg>
);

export default Micromobility;
